import { styled } from '../../styled/styled-components'

interface IWrapper {
  auth?: string
}

export const Main = styled.main`
  margin: 2rem 0;
`
export const Content = styled.div`
  height: 100%;
  display: flex;
  width: 100%;
  background: ${p => (p.theme.mode === 'light' ? '#eff3f5' : 'transparent')};
  a,
  a:hover {
    color: ${p => (p.theme.mode === 'light' ? '#383838' : 'none')};
  }
`
export const Wrapper = styled.div<IWrapper>`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  div[class^='Page__PageContent'] {
    overflow-x: hidden;
    min-height: 100vh;
    position: fixed;
    left: 0;
    padding: ${props => (props.auth ? '' : '0 190px')};
    padding-right: 0;
    width: 100%;
    height: 100%;

    @media (max-width: 1280px) {
      padding-left: ${props => (props.auth ? '' : '100px')};
    }
  }
`
